import {Component, Input} from '@angular/core';
import {ModalController} from "@ionic/angular";
import { LockedTokenHistory } from 'src/app/core/models/lockedTokenHistory.model';

@Component({
  selector: 'app-issue-modal',
  templateUrl: './issue-modal.component.html',
  styleUrls: ['./issue-modal.component.scss'],
  standalone: false
})
export class IssueModalComponent {
  @Input({ required: false }) issueTitle!: string;
  @Input({ required: false }) showTitle!: boolean;
  @Input({ required: false }) amountBlocked!: string;
  @Input({ required: false }) fiatExchangeRate!: string;
  @Input({ required: true }) issueMessage!: string;
  @Input({ required: false }) lockedTokenHistories!: LockedTokenHistory[];
  @Input({ required: true }) trigger!: string;
  @Input({ required: true }) presentingElement!: HTMLElement | undefined;

  constructor(private modalCtrl: ModalController) {}

  close() {
    return this.modalCtrl.dismiss();
  }

}
